import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Dropdown } from 'react-bootstrap';
import PictionJS from 'piction-js';
import Button from '../ui/Button';
import { isWorkbench } from '../../utils/piction';
import { showUmoExternalLink, showMetaEditTool } from '../../utils/uiUtils';
import MetadataView from '../MetadataView/MetadataView';
import { moveUmoHandler } from '../../utils/umoUtils';
import appConfig from '../../appConfig';
import CloseIcon from '../Icons/CloseIcon';
import languageIcon from '../../../icons/toolbar-icons/language.jpg';

function UMODetailViewMeta({
  dispatch,
  umo,
  toggleUMODetailView,
  selectedWorkspaceData,
  intl,
  isWorkspace,
  workspaceID,
  title,
  selectedDataLanguage,
  languageList,
  changeDataLanguage,
}) {
  const onAddToWorkspace = () => {
    const origin = {
      id: 1,
      isWorkspace,
    };
    const target = {
      id: selectedWorkspaceData.id,
      isWorkspace: true,
    };
    moveUmoHandler(origin, target, [umo.id], dispatch);
    toggleUMODetailView(false);
  };

  const onMetaEditClick = () => {
    showMetaEditTool(umo, dispatch);
    toggleUMODetailView(false);
  };

  const onLanguageChangeClick = (langIndex) => {
    changeDataLanguage(languageList[langIndex]);
  };

  return (
    <div className="umo-detail-view__meta">
      <CloseIcon
        width={32}
        height={32}
        aria-label="Close"
        onClick={() => toggleUMODetailView(false)}
        className="umo-detail-view__close-icon"
      />

      {title
        ? (
          <div className="umo-detail-view__meta-header">
            {title}
          </div>
        )
        : null }
      {appConfig.removeWorkspaces ? null : (
        <div className="umo-detail-view__meta-workspace-add">
          {
          selectedWorkspaceData.id
            ? (
              <Button
                className="umo-detail-view__meta-workspace-add-button"
                onClick={onAddToWorkspace}
                primary
              >
                {intl.formatMessage({ id: 'umoDetailView.addToWorkspaceButton' }, { workspaceName: selectedWorkspaceData.name })}
              </Button>
            )
            : (
              <Button primary disabled className="umo-detail-view__meta-workspace-add-button">
                {intl.formatMessage({ id: 'umoDetailView.addToWorkspaceGenericButton' })}
              </Button>
            )
            }
        </div>
      )}
      {
        appConfig.umoExternalLink && appConfig.umoExternalLink.title
        && appConfig.umoExternalLink.url
          ? (
            <div className="umo-detail-view__meta-reuse-image">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm umo-detail-view__meta-external-link-button"
                onClick={() => { showUmoExternalLink(dispatch, appConfig.umoExternalLink.url, umo.id, ''); }}
              >
                {appConfig.umoExternalLink.title}
              </button>
            </div>
          ) : null
      }
      <div className="umo-detail-view__meta-table">
        <h6>
          <FormattedMessage id="umoDetailView.metadataHeader" />
          {
            (isWorkbench() && appConfig.menuOptions.umoMenu.includes('editMetadata'))
              ? (
                <button onClick={onMetaEditClick} className="umo-detail-view__edit-meta-button">
                  <i className="umo-detail-view__edit-meta-icon" />
                </button>
              ) : null
          }
          {appConfig.enableMultiLang && languageList && languageList.length > 1
            ? (
              <Dropdown className="umo-detail-view__change-language-dropdown" onSelect={onLanguageChangeClick}>
                <Dropdown.Toggle variant="default" id="dropdown-basic" className="umo-detail-view__change-language-button">
                  {selectedDataLanguage && selectedDataLanguage.$ ? selectedDataLanguage.$.display : 'English'}
                  <img src={languageIcon} alt="LanguageChange" className="language-icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {languageList.map((lang, i) => (
                    <Dropdown.Item
                      key={lang._}
                      eventKey={i}
                      value={lang._}
                    >
                      {lang.$.display}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : null}
        </h6>
        <MetadataView umo={umo} toggleUMODetailView={toggleUMODetailView} dispatch={dispatch} />
      </div>
    </div>
  );
}

UMODetailViewMeta.propTypes = {
  toggleUMODetailView: PropTypes.func,
  dispatch: PropTypes.func,
  umo: PropTypes.instanceOf(PictionJS.UMO),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  isWorkspace: PropTypes.bool,
  workspaceID: PropTypes.string,
  title: PropTypes.string,
  selectedDataLanguage: PropTypes.object,
  languageList: PropTypes.array,
  changeDataLanguage: PropTypes.func,
};

export default injectIntl(UMODetailViewMeta);
